import { Box, Flex, HStack, Link as ChakraLink, Text } from "@chakra-ui/react";
import { navLinks, legalLinks } from "./NavigationBar";

export const CelestialFooter = () => (
  <Box as="footer" py={12} px={6} borderTopWidth="1px" borderColor="whiteAlpha.200">
    <Flex
      maxW="container.xl"
      mx="auto"
      direction={{ base: "column", md: "row" }}
      align={{ base: "flex-start", md: "center" }}
      justify="space-between"
      gap={6}
    >
      <Text fontSize="sm" color="whiteAlpha.700">
        © {new Date().getFullYear()} AstroSatvik. All rights reserved.
      </Text>
      <HStack gap={2} display={{ base: "none", md: "flex" }}>
        {navLinks.map((link) => (
          <ChakraLink

            key={link.href}
            href={link.href}


            px={4}
            py={2}
            borderRadius="full"
            fontSize="xs"
            letterSpacing="widest"
            textTransform="uppercase"
            fontWeight="semibold"
            color="whiteAlpha.800"
            transition="all 0.2s"
            _hover={{ bg: "whiteAlpha.100", color: "gold" }}
          >
            {link.label}
          </ChakraLink>
        ))}
        {legalLinks.map((link) => (
          <ChakraLink

            key={link.href}
            href={link.href}
            px={4}
            py={2}
            borderRadius="full"
            fontSize="xs"
            letterSpacing="widest"
            textTransform="uppercase"
            fontWeight="semibold"
            color="whiteAlpha.800"
            transition="all 0.2s"
            _hover={{ bg: "whiteAlpha.100", color: "gold" }}
          >
            {link.label}
          </ChakraLink>
        ))}
      </HStack>
    </Flex>
  </Box>
);